import request from "@/utils/request";

export interface QuestionQuery {
  current?: number;
  size?: number;
  questionCode?: string;
  questionName?: string;
  typeId?: number | null;
  status?: number | null;
}

export interface QuestionForm {
  id?: number | null;
  questionCode: string;
  questionName: string;
  typeId: number | null;
  description?: string;
  status?: number;
  sort: number;
  scoreEnabled: number;
  scoreMethod: string;
  typeName?: string;
  itemCount?: number;
  createTime?: string;
  updateTime?: string;
}

export interface QuestionCopyForm {
  id: number;
  questionCode?: string;
  questionName?: string;
}

export interface QuestionOptionForm {
  id?: number | null;
  itemId?: number | null;
  optionLabel: string;
  optionInput?: string;
  optionValue?: string;
  optionScore?: number;
  imgUrl?: string;
  isInput?: number;
  isExclusive?: number;
  sort: number;
}

export interface QuestionItemForm {
  id?: number | null;
  questionId: number | null;
  parentItemId?: number | null;
  groupId?: number | null;
  itemCode: string;
  itemTitle: string;
  itemDesc?: string;
  itemType: string;
  imgUrl?: string;
  isRequired: number;
  isShow: number;
  placeholder?: string;
  validationRule?: string;
  minSelect?: number | null;
  maxSelect?: number | null;
  scoreEnabled: number;
  scoreStrategy: string;
  sort: number;
  options: QuestionOptionForm[];
}

export interface QuestionPreview {
  question: QuestionForm;
  items: QuestionItemForm[];
  rules?: any[];
  groups?: any[];
  groupItems?: any[];
  results?: any[];
}

export interface QuestionSubmitOption {
  optionId: number;
  optionInput?: string;
}

export interface QuestionSubmitItem {
  itemId: number;
  answerText?: string;
  options?: QuestionSubmitOption[];
}

export interface QuestionSubmitForm {
  questionId: number;
  submitSource?: string;
  checkerName?: string;
  checkerGender?: string;
  checkerAge?: number | null;
  items: QuestionSubmitItem[];
}

export function getQuestionList(data: QuestionQuery): Promise<any> {
  return request({
    method: "GET",
    url: "manage/question/list",
    type: "params",
    data
  });
}

export function getQuestionDetail(id: number): Promise<any> {
  return request({
    method: "GET",
    url: "manage/question/get",
    type: "params",
    data: { id }
  });
}

export function addQuestion(data: QuestionForm): Promise<any> {
  return request({
    method: "PUT",
    url: "manage/question/add",
    data
  });
}

export function updateQuestion(data: QuestionForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/question/update",
    data
  });
}

export function deleteQuestion(id: number): Promise<any> {
  return request({
    method: "DELETE",
    url: "manage/question/delete",
    type: "params",
    data: { id }
  });
}

export function enableQuestion(id: number): Promise<any> {
  return request({
    method: "POST",
    url: "manage/question/enable",
    type: "params",
    data: { id }
  });
}

export function disableQuestion(id: number): Promise<any> {
  return request({
    method: "POST",
    url: "manage/question/disable",
    type: "params",
    data: { id }
  });
}

export function copyQuestion(data: QuestionCopyForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/question/copy",
    data
  });
}

export function getQuestionFillDetail(id: number): Promise<any> {
  return request({
    method: "GET",
    url: "manage/question/fill/detail",
    type: "params",
    data: { id }
  });
}

export function previewQuestion(id: number): Promise<any> {
  return getQuestionFillDetail(id);
}

export function submitQuestionFill(data: QuestionSubmitForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/question/fill/submit",
    data
  });
}

export function submitQuestion(data: QuestionSubmitForm): Promise<any> {
  return submitQuestionFill(data);
}

export function getQuestionItems(data: { questionId: number; keyword?: string }): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionItem/listByQuestion",
    type: "params",
    data
  });
}

export function getQuestionItemDetail(id: number): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionItem/get",
    type: "params",
    data: { id }
  });
}

export function saveQuestionItem(data: QuestionItemForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionItem/save",
    data
  });
}

export function copyQuestionItem(id: number): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionItem/copy",
    type: "params",
    data: { id }
  });
}

export function sortQuestionItems(data: {
  questionId: number;
  items: Array<{ id: number; sort: number }>;
}): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionItem/sort",
    data
  });
}

export function getNextItemCode(questionId: number): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionItem/nextCode",
    type: "params",
    data: { questionId }
  });
}

export function deleteQuestionItem(id: number): Promise<any> {
  return request({
    method: "DELETE",
    url: "manage/questionItem/delete",
    type: "params",
    data: { id }
  });
}

export function uploadQuestionImg(file: FormData): Promise<any> {
  return request({
    method: "POST",
    url: "manage/manage/upload?uploadPath=/question",
    data: file
  });
}
